import { FunctionComponent } from "react";

import Linkedin from "@assets/icons/linkedinRounded.svg?url";
import Checked from "@assets/icons/checked.svg?url";
import Failed from "@assets/icons/failed.svg?url";
import Refresh from "@assets/icons/refresh.svg?url";

export interface LinkedinIconProps {
	status?: "checked" | "failed" | "refresh";
}

export const LinkedinIcon: FunctionComponent<LinkedinIconProps> = ({ status }) => {
	return (
		<div className="relative mr-1 flex h-[20px] w-[20px] items-center justify-center">
			{status === "checked" && (
				<img alt="checked" className="absolute right-[-1px] top-[-1px]" src={Checked} />
			)}
			{status === "failed" && (
				<img alt="failed" className="absolute right-[-1px] top-[-1px]" src={Failed} />
			)}
			{status === "refresh" && (
				<img alt="refresh" className="absolute right-[-1px] top-[-1px]" src={Refresh} />
			)}
			<img alt="linkedin" className="h-[20px] w-[20px]" src={Linkedin} />
		</div>
	);
};
